import script from "./BlankTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlankTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./BlankTemplate.vue?vue&type=style&index=0&id=147fde91&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-147fde91"]])

export default __exports__